import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";

import * as States from "./models/state";
import CreateRootReducer from "./reducers";

export const history = createBrowserHistory();

export default function configureStore(
  preloadedState: States.IApplicationState
) {
  const store = createStore(
    CreateRootReducer(history), // root reducer with router state
    preloadedState,
    compose(
      applyMiddleware(
        routerMiddleware(history), // for dispatching history actions
        thunk
      )
    )
  );

  return store;
}



// WEBPACK FOOTER //
// ./src/store.ts